<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="렌탈" @rental="rental" :type="'order'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="progress">
          <ol>
            <li class="on"><span>동의</span></li>
            <li><span>본인인증</span></li>
            <li><span>결제정보입력 및 확인</span></li>
            <li><span>계약서작성</span></li>
          </ol>
        </div>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH3 normal">
              반갑습니다.
              <strong>고객님</strong>
            </h2>
            <p class="desc">렌탈 진행 및 본인인증을 위한 약관에 동의해주세요.</p>
          </div>

          <!-- 약관 (s) -->
          <div class="termsWrap">
            <div class="block accoHead">
              <input type="checkbox" class="ipt notDel uiAct chkAll" name="termsGroup1" id="terms1_all" v-model="chkAll" />
              <label for="terms1_all">전체동의</label>
            </div>

            <p class="txtXS pointC6 mb10">
              고객 편의 제공을 위하여 여러 동의사항에 대한 '전체 동의' 기능을 제공하고 있습니다.
            </p>

            <div class="accoBody" id="acco_0">
              <ul class="iptGroup">
                <li class="accoItem">
                  <div class="block accoHead">
                    <input type="checkbox" class="ipt notDel uiAct chkSubAll" name="termsSub" v-model="chkSub1All" id="terms1" value="terms1All" />
                    <label for="terms1">
                      개인(신용)정보 수집/이용/제공
                      <em>필수</em>
                      동의
                    </label>
                    <button type="button" class="btnIco_acco accoBtn" role="button" tabindex="0" aria-expanded="false" aria-controls="acco_0">
                      <span>
                        <span class="blind">상세약관</span>
                        전체보기
                      </span>
                    </button>
                  </div>
                  <div class="accoBody" id="acco_1">
                    <ul class="iptGroup">
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt notDel uiAct chkSub" name="termsSub1" id="terms1_1" value="0" v-model="chkSub" />
                          <label for="terms1_1">
                            <span>[필수]</span>
                            개인(신용)정보 수집/이용동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms1_1').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt notDel uiAct chkSub" name="termsSub1" id="terms1_2" value="1" v-model="chkSub" />
                          <label for="terms1_2">
                            <span>[필수]</span>
                            개인(신용)정보 3자제공동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms1_2').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt notDel uiAct chkSub" name="termsSub1" id="terms1_3" value="2" v-model="chkSub" />
                          <label for="terms1_3">
                            <span>[필수]</span>
                            개인(신용)정보 조회동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms1_3').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="accoItem">
                  <div class="block accoHead">
                    <input type="checkbox" class="ipt notDel uiAct chkSubAll" v-model="chkSub2All" name="termsSub" id="terms2" value="terms2All" />
                    <label for="terms2">
                      휴대폰 본인인증 서비스
                      <em>필수</em>
                      동의
                    </label>
                    <button type="button" class="btnIco_acco accoBtn" role="button" tabindex="0" aria-expanded="false" aria-controls="acco_1">
                      <span>
                        <span class="blind">상세약관</span>
                        전체보기
                      </span>
                    </button>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt notDel uiAct chkSub" name="termsSub2" id="terms2_1" value="3" v-model="chkSub" />
                          <label for="terms2_1">
                            <span>[필수]</span>
                            개인정보 수집/이용동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms2_1').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt notDel uiAct chkSub" name="termsSub2" id="terms2_2" value="4" v-model="chkSub" />
                          <label for="terms2_2">
                            <span>[필수]</span>
                            고유식별정보처리 동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms2_2').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt notDel uiAct chkSub" name="termsSub2" id="terms2_3" value="5" v-model="chkSub" />
                          <label for="terms2_3">
                            <span>[필수]</span>
                            휴대폰본인확인 이용약관동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms2_3').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt notDel uiAct chkSub" name="termsSub2" id="terms2_4" value="6" v-model="chkSub" />
                          <label for="terms2_4">
                            <span>[필수]</span>
                            통신사이용약관동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms2_4').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <div class="block accoHead">
                    <input type="checkbox" class="ipt" name="termsGroup1" id="terms3" v-model="chkSub3All" />
                    <label for="terms3">
                      상품서비스 안내 등을 위한
                      <em>선택</em>
                      동의
                    </label>
                    <button type="button" class="btnIco_acco accoBtn">
                      <span>
                        <span class="blind">상세약관</span>
                        전체보기
                      </span>
                    </button>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt" name="termsGroup1" id="terms3_1" v-model="agreeCollection" />
                          <label for="terms3_1">
                            <span>[선택]</span>
                            개인(신용)정보 수집 및 이용 동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms3_1').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>

                          <ul class="iptGroup div_3">
                            <li>
                              <input type="checkbox" class="ipt" name="chk0" id="chk0_1" v-model="agreeTel" />
                              <label for="chk0_1">전화</label>
                            </li>
                            <li>
                              <input type="checkbox" class="ipt" name="chk0" id="chk0_2" v-model="agreeSms" />
                              <label for="chk0_2">문자메세지</label>
                            </li>
                            <li>
                              <input type="checkbox" class="ipt" name="chk0" id="chk0_3" v-model="agreeDm" />
                              <label for="chk0_3">DM</label>
                            </li>
                            <li>
                              <input type="checkbox" class="ipt" name="chk0" id="chk0_4" v-model="agreeEmail" />
                              <label for="chk0_4">이메일</label>
                            </li>
                            <li>
                              <input type="checkbox" class="ipt" name="chk0" id="chk0_5" v-model="agreeAppPush" />
                              <label for="chk0_5">푸시</label>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt" name="termsGroup1" id="terms3_2" v-model="agreeCredit" />
                          <label for="terms3_2">
                            <span>[선택]</span>
                            개인(신용)정보 제공 동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms3_2').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- 약관 (e) -->

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="validate">다음</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <WebViewPop v-if="webViewPop" :pageName="pageName" @close="webviewClose" :type="'agree'">
      <div v-html="webView"></div>
      <template v-slot:closeButton>
        <button type="button" class="btnIco_close" @click="disagreement">
          <span>팝업 닫기</span>
        </button>
      </template>
    </WebViewPop>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
    <ConfirmPop @cancel="cancel" @confirm="confirm" v-if="confirmPop" @close="close">
      <p v-html="msg"></p>
    </ConfirmPop>
    <ConfirmPop @cancel="cancel2" @confirm="confirm2" v-if="confirmPop2" @close="confirmPop2 = false">
      <p v-html="msg"></p>
      <template v-slot:btnArea>동의안함</template>
      <template v-slot:btnArea2>동의함</template>
    </ConfirmPop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import WebViewPop from '@/components/popup/WebViewPop';
import MessagePop from '@/components/popup/MessagePop';
import { TERM_AGREE_CHECK, GO_HOME, TERM_AGREE_JOIN_C } from '@/store/message.type.js';
import ConfirmPop from '@/components/popup/ConfirmPop';
import $ from 'jquery';
import { isEmpty } from '@/common/common.function';
export default {
  name: 'guestStep1',
  components: {
    WebViewPop,
    MessagePop,
    ConfirmPop,
  },
  async mounted() {
    $('.btnGoTop').remove();
    //this.request = this.$route.params.request;
    //console.log(this.request);
    this.request.orderCommInfo.productCode = this.$route.params.productCode;
    this.request.orderCommInfo.internalProdCode = this.$route.params.internalProdCode;
    this.request.orderCommInfo.colorCode = this.$route.params.colorCode;
    this.paramOrderId = this.$route.params.orderId;

    ApiService.service('GET', '/order/id')
      .then(({ data }) => {
        this.request.orderCommInfo.orderId = isEmpty(this.paramOrderId) ? data.result : this.paramOrderId;
        console.log(this.request);
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });

    let webViews = await ApiService.service('GET', 'common/webView/WB000001');
    this.webViews = webViews.data.result;
    for (let url of this.webViews) {
      let res = await ApiService.service('GET', url.filePath);
      this.allUrl.push(res);
    }
    console.log(this.webViews);
  },
  data() {
    return {
      chkSubNum: '-1',
      chkSubCnt: 0,
      webViewUrl: null,
      allUrl: [],
      pageName: null,
      key: 0,
      pop: null,
      termsAll: false,
      terms: [],
      webViews: [],
      webView: null,
      webViewPop: false,
      messagePop: false,
      confirmPop: false,
      confirmPop2: false,
      msg: null,
      //request: null,
      agrAct0: true, // 전체동의
      agrAct1: true, // 1번 약관동의 액션 세이프키
      agrAct2: true, // 2번 약관동의 액션 휴대폰
      agrAct3: true, // 3번 약관동의 액션 상품서비스
      chkAll: false, // 전체동의
      chkSub: [], // 필수, 선택 동의 여부
      chkSub1All: false,
      chkSub2All: false,
      chkSub3All: false,
      agreeAppPush: false,
      agreeCollection: false,
      agreeDm: false,
      agreeEmail: false,
      agreeSms: false,
      agreeTel: false,
      agreeCredit: false,

      // selectAgreeInfo: {
      //   agreeAppPush: false,
      //   agreeCollection: false,
      //   agreeCredit: false,
      //   agreeDm: false,
      //   agreeEmail: false,
      //   agreeSms: false,
      //   agreeTel: false,
      // },

      paramOrderId: '',
      request: {
        conOrderInfo: {
          // 거주지 정보
          cellNum: '',
          conAddrCode: '',
          conAddrJibun: '',
          conAddrPost: '',
          conAddrRemark: '',
          conAddrRoad: '',
          customerName: '',
          localUserYn: '', // 내국인 여부. Y: 내국인
          sex: '',
          ssn: '',
          userIdentityComp: '', // 통신사 코드
        },
        installInfo: {
          // 설치지 정보
          installAddrCode: '',
          installAddrJibun: '',
          installAddrPost: '',
          installAddrRemark: '',
          installAddrRoad: '',
          installCellNum: '', // 배송연락처 휴대폰번호
          installReqDate: '', // 설치/배송 예상일 (형식: YYYYMMDD)
          installUserName: '', // 배송연락처 이름
        },
        joinInfo: {
          // 비회원의 경우 간편 회원가입. 회원이면 joinYn을 N으로 보내주세요.
          joinYn: '', // 간편렌탈 가입여부 (Y:체크됨, N:체크해제됨)
          password: '', // 비밀번호
          selectedAgree3: '', // 상품서비스 안내 등을 위한 선택 동의여부 (selectAgreeInfo 와 달리 Y/N으로 보내주세요)
          userId: '', // 아이디
        },
        orderCommInfo: {
          colorCode: '',
          productCode: '',
          internalProdCode: '',
          orderId: '', // 주문번호
          orderStatus: 'RSTA00PR', // 내부 상태 구분값 (RSTA00RP: 주문접수 완료, RSTA00PR: 사전주문접수)
          safekey: '', // 신용조회 후 발급받은 세이프키
          saleType: 'RORT00GE', // 주문구분 (렌탈: RORT00GE, 일시불: RORT00SE)
        },
        payInfo: {
          bankAccnt: '', // 계좌번호 (- 없이 숫자만)
          bankCode: '', // 은행코드
          cardExpireDate: '', // 카드 유효기간 (형식: MMYY)
          cardName: '', // 카드사코드
          cardNumber: '', // 카드번호 (- 없이 숫자만)
          cashNum: '', // 현금영수증 발급할 전화번호
          cashReqYn: '', // 현금영수증 발급여부 (Y: 발급, N: 발급안함)
          checkType: '', // 결제수단 구분 (RDUT00CM: 계좌, RDUT00CC: 카드)
          couponCd: '', // 쿠폰코드
          dueDate: '', // 결제일
          rmanCd: '', // 추천코드
          secureKeyPad: '', // 보안키패드 사용여부 (Y: 사용, N: 사용안함)
        },
        selectAgreeInfo: {
          agreeAppPush: 'SLAG0002',
          agreeCollection: 'SLAG0002',
          agreeCredit: 'SLAG0002',
          agreeDm: 'SLAG0002',
          agreeEmail: 'SLAG0002',
          agreeSms: 'SLAG0002',
          agreeTel: 'SLAG0002',
        },
        chkSub3All: false,
        coupon: null,
      },
    };
  },
  watch: {
    chkSub() {
      console.log(this.chkSub);
      if (this.chkSub.length - this.chkSubCnt == 1) {
        this.openPop(this.chkSub[this.chkSub.length - 1]);
      } else if (this.chkSub.length - this.chkSubCnt == -1) {
        const chk1 = this.chkSub.includes('0');
        const chk2 = this.chkSub.includes('1');
        const chk3 = this.chkSub.includes('2');
        const chk4 = this.chkSub.includes('3');
        const chk5 = this.chkSub.includes('4');
        const chk6 = this.chkSub.includes('5');
        const chk7 = this.chkSub.includes('6');
        if (this.chkSub1All) {
          if (!chk1 || !chk2 || !chk3) {
            this.agrAct1 = false;
            this.chkSub1All = false;
          }
        }
        if (this.chkSub2All) {
          if (!chk4 || !chk5 || !chk6 || !chk7) {
            console.log('291');
            this.agrAct2 = false;
            this.chkSub2All = false;
          }
        }
      }
      this.chkSubCnt = this.chkSub.length;
      console.log(this.chkSubCnt);
    },
    chkAll() {
      //전체 선택은 체크 하되 하위액션은 X
      console.log('chkAll' + this.agrAct0);
      if (this.agrAct0 == false) {
        this.agrAct0 = true;
        return false;
      }
      //약관 초기화
      this.chkSub = [];
      this.agrAct1 = true;
      this.agrAct2 = true;
      this.agrAct3 = true;
      this.agreeAppPush = false;
      this.agreeCollection = false;
      this.agreeDm = false;
      this.agreeEmail = false;
      this.agreeSms = false;
      this.agreeTel = false;
      this.agreeCredit = false;
      if (this.chkAll) {
        console.log('open');
        this.openPop(-1);
        this.chkSub1All = true;
        this.chkSub2All = true;
        this.chkSub3All = true;

        const array_termsSub = document.getElementsByName('termsSub1');
        for (let i = 0; i < array_termsSub.length; i++) {
          console.log(array_termsSub[i].value);
          this.chkSub.push(array_termsSub[i].value);
          console.log(this.chkSub);
        }

        const array_termsSub2 = document.getElementsByName('termsSub2');

        for (let i = 0; i < array_termsSub2.length; i++) {
          console.log(array_termsSub2[i].value);
          this.chkSub.push(array_termsSub2[i].value);
        }

        this.agreeAppPush = true;
        this.agreeCollection = true;
        this.agreeDm = true;
        this.agreeEmail = true;
        this.agreeSms = true;
        this.agreeTel = true;
        this.agreeCredit = true;
      } else {
        this.chkSub = [];
        this.agrAct1 = false;
        this.agrAct2 = false;
        this.agrAct3 = false;
        this.chkSub1All = false;
        this.chkSub2All = false;
        this.agreeAppPush = false;
        this.agreeCollection = false;
        this.agreeDm = false;
        this.agreeEmail = false;
        this.agreeSms = false;
        this.agreeTel = false;
        this.agreeCredit = false;
      }
    },
    chkSub1All() {
      if (this.chkAll && this.chkSub1All && this.chkSub2All && this.chkSub3All) {
        console.log('chkAll');
      } else if (this.chkSub1All && this.chkSub2All && this.chkSub3All) {
        this.agrAct0 = false;
        this.chkAll = true;
      } else {
        if (this.chkSub2All && this.chkSub3All) {
          this.agrAct0 = false;
        }
        this.chkAll = false;
      }
      //전체 선택은 체크 하되 하위액션은 X
      if (this.agrAct1 == false) {
        this.agrAct1 = true;
        return false;
      }

      if (this.chkSub1All) {
        const array_termsSub = document.getElementsByName('termsSub1');
        for (let i = 0; i < array_termsSub.length; i++) {
          this.chkSub = this.chkSub.filter(item => item !== array_termsSub[i].value);
        }
        const array_termsSub_bak = document.getElementsByName('termsSub1');
        for (let i = 0; i < array_termsSub_bak.length; i++) {
          this.chkSub.push(array_termsSub_bak[i].value);
          console.log(this.chkSub);
        }
        this.openPop(-2);
      } else {
        const array_termsSub = document.getElementsByName('termsSub1');
        for (let i = 0; i < array_termsSub.length; i++) {
          this.chkSub = this.chkSub.filter(item => item !== array_termsSub[i].value);
        }
      }
    },
    chkSub2All() {
      if (this.chkAll && this.chkSub1All && this.chkSub2All && this.chkSub3All) {
        console.log('chkAll');
      } else if (this.chkSub1All && this.chkSub2All && this.chkSub3All) {
        this.agrAct0 = false;
        this.chkAll = true;
      } else {
        if (this.chkSub1All && this.chkSub3All) {
          this.agrAct0 = false;
        }
        this.chkAll = false;
      }
      if (this.agrAct2 == false) {
        this.agrAct2 = true;
        return false;
      }

      if (this.chkSub2All) {
        const array_termsSub = document.getElementsByName('termsSub2');
        for (let i = 0; i < array_termsSub.length; i++) {
          this.chkSub = this.chkSub.filter(item => item !== array_termsSub[i].value);
        }

        const array_termsSub_bak = document.getElementsByName('termsSub2');

        for (let i = 0; i < array_termsSub_bak.length; i++) {
          this.chkSub.push(array_termsSub_bak[i].value);
        }

        this.openPop(-3);
      } else {
        const array_termsSub = document.getElementsByName('termsSub2');
        for (let i = 0; i < array_termsSub.length; i++) {
          this.chkSub = this.chkSub.filter(item => item !== array_termsSub[i].value);
        }
      }
    },
    chkSub3All() {
      if (this.chkAll && this.chkSub1All && this.chkSub2All && this.chkSub3All) {
        console.log('chkAll');
      } else if (this.chkSub1All && this.chkSub2All && this.chkSub3All) {
        this.agrAct0 = false;
        this.chkAll = true;
      } else {
        if (this.chkSub2All && this.chkSub1All) {
          this.agrAct0 = false;
        }
        this.chkAll = false;
      }

      if (this.agrAct3 == false) {
        this.agrAct3 = true;
        return false;
      }

      if (this.chkSub3All && this.agreeCollection && this.agreeCredit) {
        console.log('chkAll');
      } else if (this.chkSub3All) {
        this.openPop(-4);

        this.agreeAppPush = true;
        this.agreeCollection = true;
        this.agreeCredit = true;
        this.agreeDm = true;
        this.agreeEmail = true;
        this.agreeSms = true;
        this.agreeTel = true;
      } else {
        this.agreeAppPush = false;
        this.agreeCollection = false;
        this.agreeCredit = false;
        this.agreeDm = false;
        this.agreeEmail = false;
        this.agreeSms = false;
        this.agreeTel = false;
      }
    },
    agreeCollection() {
      console.log(this.agreeCollection && (this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel));

      if (this.agreeCollection && (this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
        if (this.agreeCredit && !this.chkSub3All) {
          this.agrAct3 = false;
          this.chkSub3All = true;
        }
      } else if (this.agreeCollection) {
        this.openPop(7);
        this.agreeAppPush = true;
        this.agreeCollection = true;
        this.agreeDm = true;
        this.agreeEmail = true;
        this.agreeSms = true;
        this.agreeTel = true;
      } else {
        this.agreeAppPush = false;
        this.agreeCollection = false;
        this.agreeDm = false;
        this.agreeEmail = false;
        this.agreeSms = false;
        this.agreeTel = false;

        if (this.chkSub3All) {
          this.agrAct3 = false;
          this.chkSub3All = false;
        }
      }
    },
    agreeCredit() {
      if (!this.agreeCredit && this.chkSub3All) {
        this.agrAct3 = false;
        this.chkSub3All = false;
      }
      if (this.agreeCredit && !this.chkAll && !this.chkSub3All) {
        this.openPop(8);
      }
    },
    agreeAppPush() {
      if (this.agreeAppPush) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
    agreeDm() {
      if (this.agreeDm) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
    agreeEmail() {
      if (this.agreeEmail) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
    agreeSms() {
      if (this.agreeSms) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
    agreeTel() {
      if (this.agreeTel) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
  },
  methods: {
    nextStep() {
      this.request.selectAgreeInfo.agreeAppPush = this.agreeAppPush ? 'SLAG0001' : 'SLAG0002';
      this.request.selectAgreeInfo.agreeCollection = this.agreeCollection ? 'SLAG0001' : 'SLAG0002';
      this.request.selectAgreeInfo.agreeCredit = this.agreeCredit ? 'SLAG0001' : 'SLAG0002';
      this.request.selectAgreeInfo.agreeDm = this.agreeDm ? 'SLAG0001' : 'SLAG0002';
      this.request.selectAgreeInfo.agreeEmail = this.agreeEmail ? 'SLAG0001' : 'SLAG0002';
      this.request.selectAgreeInfo.agreeSms = this.agreeSms ? 'SLAG0001' : 'SLAG0002';
      this.request.selectAgreeInfo.agreeTel = this.agreeTel ? 'SLAG0001' : 'SLAG0002';
      if (this.agreeCredit || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel) this.request.chkSub3All = true;
      //this.request.chkSub3All = this.agreeCollection;

      this.$router.replace({
        name: 'guestStep2',
        params: { request: this.request },
      });
    },
    validate() {
      const chk1 = this.chkSub.includes('0');
      const chk2 = this.chkSub.includes('1');
      const chk3 = this.chkSub.includes('2');
      const chk4 = this.chkSub.includes('3');
      const chk5 = this.chkSub.includes('4');
      const chk6 = this.chkSub.includes('5');
      const chk7 = this.chkSub.includes('6');

      if (chk1 && chk2 && chk3 && chk4 && chk5 && chk6 && chk7) {
        if (!this.agreeCollection && !this.agreeCredit) {
          this.msg = TERM_AGREE_JOIN_C;
          this.confirmPop2 = true;
        } else {
          this.nextStep();
        }
      } else {
        console.log(this.messagePop);
        this.pop = MessagePop;
        this.msg = TERM_AGREE_CHECK;
        this.messagePop = true;
      }
    },
    async openPop(num) {
      //this.pageName = pageName;
      if (this.webViewPop) return false;
      this.webViewPop = true;
      this.chkSubNum = num;

      if (num < 0) {
        if (num == -1) {
          this.pageName = '전체 약관';
        } else if (num == -2) {
          this.pageName = '개인(신용)정보 수집/이용/제공 관련 약관';
        } else if (num == -3) {
          this.pageName = '휴대폰 본인인증 관련 약관';
        } else if (num == -4) {
          this.pageName = '상품서비스 안내등을 위한 약관';
        }

        let html = '';
        for (let i = 0; i < this.allUrl.length; i++) {
          if (num == -2 && i > 2) {
            continue;
          }
          if (num == -3 && (i < 3 || i > 6)) {
            continue;
          }
          if (num == -4 && i < 7) {
            continue;
          }
          console.log(i);
          let res = this.allUrl[i];
          html += res.data;
        }

        this.webView = html;
      } else {
        this.webViewUrl = this.webViews[num].filePath;
        this.pageName = this.webViews[num].pageName;
        let res = this.allUrl[num];
        this.webView = res.data;
        this.webViewPop = true;
      }
    },
    webviewClose() {
      console.log(this.chkSubNum);
      if (this.chkSubNum > -1) {
        if (!this.chkSub1All && this.chkSub.includes('0') && this.chkSub.includes('1') && this.chkSub.includes('2')) {
          this.agrAct1 = false;
          this.chkSub1All = true;
        }
        if (!this.chkSub2All && this.chkSub.includes('3') && this.chkSub.includes('4') && this.chkSub.includes('5') && this.chkSub.includes('6')) {
          this.agrAct2 = false;
          this.chkSub2All = true;
        }
        if (!this.chkSub3All && this.agreeCredit && this.agreeCollection) {
          this.agrAct3 = false;
          this.chkSub3All = true;
        }
      }
      this.webViewPop = false;
    },
    close() {
      this.messagePop = false;
      this.confirmPop = false;
      this.bottomPop = false;
      this.noticePop = false;
      this.webViewPop = false;
      this.sharePop = false;
      this.findAddr = false;
    },
    disagreement() {
      let num = this.chkSubNum.toString();
      console.log(num);
      if (num == -1) {
        this.agrAct0 = true;
        this.chkAll = false;
      } else if (num == -2) {
        this.chkSub1All = false;
      } else if (num == -3) {
        this.chkSub2All = false;
      } else if (num == -4) {
        this.chkSub3All = false;
      } else if (num == '7') {
        this.agreeCollection = false;
      } else if (num == '8') {
        this.agreeCredit = false;
      } else {
        for (let i = 0; i < this.chkSub.length; i++) {
          if (num == this.chkSub[i].toString()) {
            this.chkSub.splice(i, 1);
          }
        }
      }

      console.log(this.chkSub);
      this.webViewPop = false;
    },
    rental() {
      this.msg = GO_HOME;
      this.confirmPop = true;
    },
    cancel() {
      // 취소 선택시 팝업 닫기
      this.confirmPop = false;
    },
    confirm() {
      // 확인 선택시 장바구니에 담고 페이지이동
      // TODO 장바구니 추가 API 호출
      this.$router.replace('/');
    },
    cancel2() {
      this.nextStep();
      this.confirmPop = false;
    },
    confirm2() {
      this.confirmPop = false;
      this.chkSub3All = true;
      this.agreeAppPush = true;
      this.agreeCollection = true;
      this.agreeCredit = true;
      this.agreeDm = true;
      this.agreeEmail = true;
      this.agreeSms = true;
      this.agreeTel = true;
      this.request.chkSub3All = true;
      this.nextStep();
    },
  },
};
</script>
